"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.rag.description': 'Configura le impostazioni RAG (Generazione Aumentata dal Recupero) per l\'elaborazione delle conoscenze AI',
    'settings.rag.failedToLoad': 'Impossibile caricare le impostazioni RAG',
    'settings.rag.savedSuccessfully': 'Impostazioni RAG salvate con successo',
    'settings.rag.failedToSave': 'Impossibile salvare le impostazioni RAG',
    'settings.rag.save': 'Salva Impostazioni RAG',
    'settings.rag.indexing.title': 'Impostazioni di Indicizzazione',
    'settings.rag.indexing.chunkSize': 'Dimensione Frammento',
    'settings.rag.indexing.chunkSize.help': 'Numero massimo di caratteri per frammento di testo (100-10000)',
    'settings.rag.indexing.chunkOverlap': 'Sovrapposizione Frammenti',
    'settings.rag.indexing.chunkOverlap.help': 'Numero di caratteri sovrapposti tra frammenti (0-1000)',
    'settings.rag.indexing.separators': 'Separatori di Testo',
    'settings.rag.indexing.separators.placeholder': 'Inserisci separatori separati da virgole (es. .\\n\\n, \\n)',
    'settings.rag.indexing.separators.help': 'Caratteri o stringhe utilizzati per dividere il testo in frammenti. Usa \\n per i ritorni a capo, \\t per le tabulazioni. Separa più valori con virgole.',
    'settings.rag.search.title': 'Impostazioni di Ricerca',
    'settings.rag.search.defaultMaxResults': 'Massimo Risultati Predefinito',
    'settings.rag.search.defaultMaxResults.help': 'Numero predefinito di risultati di ricerca da restituire (1-50)',
    'settings.rag.search.maxResults': 'Massimo Risultati',
    'settings.rag.search.maxResults.help': 'Numero massimo di risultati di ricerca consentiti (1-100)',
    'settings.rag.search.similarityThreshold': 'Soglia di Similarità',
    'settings.rag.search.similarityThreshold.help': 'Punteggio minimo di similarità per i risultati di ricerca (0-1)',
};
